var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 879,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pattern-six_svg__clip0_1106_701)",
    fill: "#F87C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.7-10.5v841.875H91.954a.284.284 0 00-.108.021.281.281 0 00-.172.262v161.851H-22v-17.497h96.202V831.644a17.81 17.81 0 015.204-12.566 17.76 17.76 0 0112.548-5.214h55.273V-10.514l17.473.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.039 0v945.479l-41.791.713v-89.308h-48.48v-17.496h65.952v89.006l6.846-.115V0h17.473z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pattern-six_svg__clip0_1106_701"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(0 -1 1 0 0 879)",
    d: "M0 0h879v270H0z"
  })))));
}
export default SvgIconPatternSix;